import React from 'react';
import { compose } from 'redux';

import { branch } from '../../common/utils/general/branch';
import { withImageUpload } from '../../common/containers/helpersCreatorContainer';
import withCreateMutation from './helpersCreatorContainer/withCreateMutation';

export const CreatorContainer = (WrappedComponent, options = {}) => {
	const { middlewareHOC, imageUpload } = options;

	const ComposedComponent = compose(
		branch(() => middlewareHOC, middlewareHOC),
		branch(props => props.imageUpload || imageUpload, withImageUpload),
		withCreateMutation,
	)(WrappedComponent);

	return React.memo(ComposedComponent);
};
